import type { HTMLAttributes } from 'react';
import { cn } from './utils';

export type SkeletonProps = HTMLAttributes<HTMLDivElement> & {
  /** Shape preset. */
  shape?: 'rect' | 'circle' | 'text';
};

/**
 * Loading placeholder. Animates a soft shimmer over a muted ink-100 background
 * (uses the existing `shimmer-bg` keyframes).
 */
export function Skeleton({ shape = 'rect', className, ...rest }: SkeletonProps) {
  return (
    <div
      {...rest}
      className={cn(
        'relative overflow-hidden bg-ink-100',
        shape === 'circle' && 'rounded-full',
        shape === 'rect' && 'rounded-lg',
        shape === 'text' && 'rounded h-3 w-full',
        className,
      )}
    >
      <span className="absolute inset-0 shimmer-bg opacity-40" />
    </div>
  );
}
